import RequisitesList from './RequisitesList';

export default RequisitesList;
